// import React from "react";
// import "./Hero.css";
// import heroBg from "../../../assets/images/girl.webp";

// const Hero = () => {
//   return (
//     <header
//       className="hero"
//       style={{ backgroundImage: `url(${heroBg})` }}
//       role="banner"
//       aria-label="Welcome to Envision"
//     >
//       <div className="hero-overlay">
//         {/* SEO: Only ONE H1 on page */}
//         <h1 className="hero-title">Welcome to Envision</h1>

//         {/* SEO-friendly supporting text */}
//         <p className="hero-subtitle">
//           Professional digital solutions designed to grow your business
//         </p>
//       </div>
//     </header>
//   );
// };

// export default Hero;




import React from "react";
import "./Herobanner.css";
import heroImg from "../../.././assets/images/hr.png";

const HeroBannerSection = () => {
  return (
    <section className="hbs-wrapper">
      <div className="hbs-container">
        {/* LEFT CONTENT */}
        <div className="hbs-content">
          <h1 className="hbs-heading">
            <span className="hbs-highlight">All-in-One HR,</span>
            <br />
            Payroll & Recruitment Platform
          </h1>

          <p className="hbs-description">
            Core HR management, performance management, workflows, attendance
            management, payroll, leave management, task management, onboarding
            and recruitment made simple.
          </p>

          <div className="hbs-button-group">
            <button className="hbs-btn-primary">
              Start 14-day Free Trial
            </button>
            <button className="hbs-btn-secondary">
              Schedule a Demo
            </button>
          </div>

          <div className="hbs-note-row">
            <span>✔ No Credit Card Required</span>
            <span>✔ No Commitment</span>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="hbs-image-box">
          <img src={heroImg} alt="HR Dashboard" />
        </div>
      </div>

      {/* TRUSTED COUNTER */}
      <div className="hbs-counter-strip">
        <div className="hbs-counter-item">
          <h2>10K+</h2>
          <p>Companies</p>
        </div>

        <div className="hbs-divider" />

        <div className="hbs-counter-item">
          <h2>1.5M</h2>
          <p>Employees</p>
        </div>

        <div className="hbs-divider" />

        <div className="hbs-counter-item">
          <h2>150+</h2>
          <p>Features</p>
        </div>

        <div className="hbs-divider" />

        <div className="hbs-counter-item">
          <h2>100+</h2>
          <p>Cities</p>
        </div>
      </div>
    </section>
  );
};

export default HeroBannerSection;
